import { Team, User } from 'api/models';
import { fullName } from 'utils/full-name';
import { isUser } from 'utils/is-user';
import { MentionSuggestion, MentionType } from '..';

interface Args {
  data: Team[] | User[];
  index: number;
  type: MentionType;
}

export const generateSuggestionItem = ({
  data,
  index,
  type,
}: Args): MentionSuggestion => {
  const datum = data[index];

  return {
    name: isUser(datum) ? fullName(datum) : datum.teamName,
    photoUrl: isUser(datum) ? datum.photoUrl : undefined,
    type,
    objectId: isUser(datum) ? datum.userId : datum.teamId,
  };
};
